import React, { FC } from "react";
import imagePng from "images/rolands.jpg";
import HeroSearchForm from "components/HeroSearchForm/HeroSearchForm";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootStore } from "functions/redux/store";
import { firstCapital } from "functions/common";

export interface SectionHeroProps {
  className?: string;
}

const SectionHero: FC<SectionHeroProps> = ({ className = "" }) => {
  const { t } = useTranslation();
  const { user } = useSelector((state: RootStore) => state);
  return (
    <div
      className={`nc-SectionHero flex flex-col md:flex-col-reverse lg:flex-col relative ${className}`}
      data-nc-id="SectionHero"
    >
      <div className="flex flex-col lg:flex-row lg:items-center">
        <div className="flex-shrink-0 lg:w-1/2 flex flex-col items-start space-y-8 sm:space-y-10  lg:pb-64 xl:pr-14 lg:mr-10 xl:mr-0">
          <h2 className="font-medium text-4xl md:text-5xl xl:text-7xl leading-[110%]">
            {user.credential && user.credential.profile ? `Hallo ${firstCapital(user.credential.profile.displayName.split(' ')[0])}!` : 'Hi There!'}
          </h2>
          <span className="text-base md:text-lg text-neutral-500 dark:text-neutral-400">
            {t('tagline_desc')}
          </span>
        </div>
        <div className="flex-grow hidden md:block">
          <img className="w-full" src={imagePng} alt="hero" />
        </div>
      </div>

      <div className="z-10 mb-18 lg:mb-0 lg:-mt-40 w-full">
        <HeroSearchForm />
      </div>

    </div>
  );
};

export default SectionHero;
